import Vue from 'vue';
import jwtDecode from 'jwt-decode';

import Auth from '@/store/api/auth';

// initial state

const token = Auth.getToken();
const jwt = token ? jwtDecode(token) : {};

const state = {
    // signin: ((Auth.getToken() !== null)),
    member: {},
    token,
    jwt
};

// getters
const getters = {
    member: state => state.member,
    isAuthenticated: state => !!state.token,
    token: state => state.token
};

// actions
const actions = {
    register({ commit }, member) {
        return Auth.register(member).then(({ data }) => {
            const { token, member } = data;
            commit('addTokenToState', token);
            // commit('addAuthenticatedMemberToState', member); // getting done by fetchAuthenticatedMember
            commit('mapRouter', null, { root: true });
        });
    },
    signin({ commit }, member) {
        return Auth.login(member).then(({ data }) => {
            const { token, member } = data;
            commit('addTokenToState', token);
            // commit('addAuthenticatedMemberToState', member); // getting done by fetchAuthenticatedMember
            commit('mapRouter', null, { root: true });
        });
    },
    signout({ commit }) {
        // // commit('authRemove');
        // // commit('mapRouter', null, { root: true });
        // // commit(
        // //     'shop/setCart',
        // //     {
        // //         qty: 0,
        // //         sum: 0,
        // //         articles: []
        // //     },
        // //     { root: true }
        // // );
        // // commit('shop/setCartInitialised', false, { root: true });
        // // return Auth.removeToken();

        // router.push('/');

        // setTimeout(() => {
        //   commit('authRemove');
        //   Auth.removeToken();

        //   commit('mapRouter', null, { root: true });
        //   commit('shop/setCartInitialised', false, { root: true });
        //   dispatch('shop/initCart', null, { root: true });
        //   // router.go(0);
        // }, 0);

        Auth.removeToken();
        Vue.nextTick(() => {
            // router.go({ path: "/", force: true })
            window.location.replace('/');
        });
    },
    fetchAuthenticatedMember({ commit, dispatch }) {
        return Auth.fetchAuthenticatedMember()
            .then(member => {
                commit('addAuthenticatedMemberToState', member);
                dispatch('shop/initCart', member, { root: true });
            })
            .catch(error => {
                console.error(error);
                commit('authRemove');
                commit('mapRouter', null, { root: true });
                Auth.removeToken();
            });
    },
    sendResetLinkEmail({ commit }, payload) {
        return Auth.sendResetLinkEmail(payload);
    },
    resetPassword({ commit }, payload) {
        return Auth.resetPassword(payload).then(({ data }) => {
            // console.log(data);
        });
    },
    verifyEmail({ commit }, payload) {
        return Auth.verifyEmail(payload).then(({ data }) => {
            console.log(data);
        });
    }
};

// mutations
const mutations = {
    addTokenToState(state, token) {
        if (token !== undefined) {
            const decodedJWT = jwtDecode(token);

            state.token = token;
            state.jwt = decodedJWT;
            // state.signin = true

            Auth.setToken(token);
        } else {
            throw 'Authetication failed: Token undefined';
        }
    },
    addAuthenticatedMemberToState(state, member) {
        if (member !== undefined) {
            member = _.cloneDeep(member);
            delete member.customer.shoppingCart;

            state.member = member;
        } else {
            throw 'Authetication failed: Member undefined';
        }
    },
    updateMemberSettings(state, settings) {
        state.member.settings = settings;
    },
    authFail(state) {
        state.signin = false;
        Auth.removeToken();
    },
    // authReset (state) {
    // },
    // authForgot (state) {
    // },
    authRemove(state) {
        state.token = undefined;
        state.jwt = undefined;
        state.member = {};
    }
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
};
